import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AdminService } from "../../../services/admin.service";
import { apiUrl } from "../../../global/global";
import { ToastrService } from "ngx-toastr";
import { UserDetailsService } from "src/app/services/user/user-details.service";
@Component({
  selector: "app-notification",
  templateUrl: "./notification.component.html",
  styleUrls: ["./notification.component.css"]
})
export class NotificationComponent implements OnInit {

  isNotificationSetting:any;
  isNotificationSMSSetting:any
  public userDatas: any;
  public userPermissionData: any;

  constructor(private toastrService: ToastrService, private router: Router, private api: AdminService,private userDetailsService: UserDetailsService) { 
    this.userDetailsService.getRecruiterUserData();
    this.userDetailsService.userDetailsObserver.subscribe(userData => {
      this.userDatas = userData; 
    });
    this.userDetailsService.getRecruiterPermission();
    this.userDetailsService.userPermissionObserver.subscribe(res => {
      this.userPermissionData = res; 
    });
  }

  ngOnInit(): void {
    this.isNotificationSetting= localStorage.getItem("isNotificationSetting");
    this.isNotificationSMSSetting= localStorage.getItem("isNotificationSMSSetting");
  }

  emailNotification(event:any){
    if(event.target.checked == false){
      this.isNotificationSetting = 1
    }else { 
      this.isNotificationSetting = 0 
    }
    this.api.putData(apiUrl._recurringNotification,{"isNotificationSetting" : this.isNotificationSetting})
    .subscribe(res => { 
      this.toastrService.success("Updated Successfully");
      localStorage.setItem("isNotificationSetting", this.isNotificationSetting);
    },
    err => {
      console.log(err);   
    });
  }

  smsNotification(event:any){
    if(event.target.checked == false){
      this.isNotificationSMSSetting = 1
    }else { 
      this.isNotificationSMSSetting = 0 
    }
    this.api.putData(apiUrl._recurringNotification,{"isNotificationSMSSetting" : this.isNotificationSMSSetting})
    .subscribe(res => { 
      this.toastrService.success("Updated Successfully");
      localStorage.setItem("isNotificationSMSSetting", this.isNotificationSMSSetting) 
    },
    err => {
      console.log(err);   
    });
  }

}
